import { useDispatch, useSelector } from 'react-redux';
import FJStrokePanel from '../../../../common/components/FJStrokePanel/FJStrokePanel';
import FJActionPhotoBgRemover from '../../../../redux/action/FJActionPhotoBgRemover';
import { useMemo } from 'react';
import FJConstant from '../../../../constants/FJConstant';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJPhotoRemoveStrokeContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const strokeApplyToAll = useSelector(state => state.photoBgRemover.strokeApplyToAll);
    const strokeInfo = useSelector(state => state.imageStroke.strokeInfo);
    const isCustomRemoveBg = useSelector(state => state.photoBgRemover.curMenuIndex === 1);
    const autoBgImageDataList = useSelector(state => state.photoBgRemover.autoBgImageDataList);

    const isShowApplyToAll = useMemo(() => {
        return !isCustomRemoveBg && autoBgImageDataList && autoBgImageDataList.length > 1;
    }, [isCustomRemoveBg, autoBgImageDataList]);

    const selectedStrokeType = useMemo(() => {
        return strokeInfo.type;
    }, [strokeInfo]);

    const handleApplyToAll = value => {
        dispatch(FJActionPhotoBgRemover.strokeApplyToAllAction(value));
    };

    const onStrokeInfoChange = (data, changeType = FJConstant.CHANGE_END, isStrokeTypeChange = false) => {
        dispatch(FJActionPhotoBgRemover.setStrokeInfoAction(data, changeType, isStrokeTypeChange));
    };

    return (
        <FJStrokePanel
            strokeApplyToAll={strokeApplyToAll}
            strokeInfo={strokeInfo}
            selectedStrokeType={selectedStrokeType}
            isShowApplyToAll={isShowApplyToAll}
            handleApplyToAll={handleApplyToAll}
            onStrokeInfoChange={onStrokeInfoChange}
        />
    );
};

export default FJPhotoRemoveStrokeContainer;
